import MobileContentContainer from "@Route/features/mobile/components/MobileContentContainer";
import SeatClass from "@Route/components/SeatClass/SeatClass";
import PriceWithCurrency from "@Route/components/Price/PriceWithCurrency";
import BuyButton from "@Route/features/ticketPurchase/components/BuyButton";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import ParamsType from "@SearchResults/types/params/Params.type";
import React, {useState} from "react";
import MobileSummarySection from "@Route/features/mobile/components/MobileSummarySection";

type MobilePassengerClassesProps = {
    preparedRoute: RouteWithAddedPropsAndPricesType
    params: ParamsType,
    isReturn: boolean,
}

function MobilePassengerClasses({preparedRoute, params, isReturn}: MobilePassengerClassesProps) {
    const activeClasses = preparedRoute.passengerClasses.map((passengerClass) => (passengerClass.travelInfo.seatClass))
    const [activeClassIndex, setActiveClassIndex] = useState(0)
    const activeClass = preparedRoute.passengerClasses[activeClassIndex]

    return (
        <>
            <div className="gb--tabs gb--row gb--row-middle">
                <ul className="nav nav-tabs gb--tabs-nav">
                    {activeClasses.map((seatClass, index) => (
                        <li
                            key={seatClass.className}
                            className={`nav-item gb--row ${index === activeClassIndex ? 'active' : 'inactive'}`}
                        >
                            <button
                                style={{alignItems: 'center'}}
                                className="nav-link gb--tab-link"
                                type="button"
                                onClick={() => setActiveClassIndex(index)}
                            >
                                {seatClass.className}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            <MobileContentContainer
                title=""
            >
                <SeatClass
                    displayImages
                    displayDescription
                    seatClass={activeClass.travelInfo.seatClass}
                    classNameDecoration={(
                        <PriceWithCurrency
                            price={activeClass.prices?.price}
                        />
                    )}
                >
                    <BuyButton
                        style={{margin: 0, width: '33%'}}
                        route={activeClass}
                        params={params}
                    />
                </SeatClass>
            </MobileContentContainer>
            <MobileSummarySection
                isReturn={isReturn}
                route={activeClass}
                params={params}
            />
        </>
    );
}

export default MobilePassengerClasses;